export class BaseWbFlightLog {
  wbFlightOid: number;
  wbConfigMainOid: number;
  flightDate: Date;
  flightNumber: string;
  flightLegOriginal: number;
  flightLeg: string;
  reopenCtr: number;
  legDate: Date;
  origin: string;
  destination: string;
  flightRoute: string;
  originCountryName: string;
  originDomesticInternationalFlag: string;
  originRegionName: string;
  destinationCountryName: string;
  destinationDomesticInternationalFlag: string;
  destinationRegionName: string;
  domesticToDomesticIndicator: number;
  internationalToInternationalIndicator: number;
  domesticToInternationalIndicator: number;
  internationalToDomesticIndicator: number;
  intraDomesticInternationalIndicator: number;
  mixedDomesticInternationalIndicator: number;
  aircraftRegistrationNumber: string;
  acn: string;
  equipCodeNumber: number;
  equipCode: string;
  fleetCode: string;
  fleetModelCode: string;
  statusFlag: string;
  acnStatusFlagDescription: string;
  projectedPayload: number;
  upperCargoWeight: number;
  lowerCargoWeight: number;
  payloadCheck: number;
  jumpseatQuantity: number;
  jumpseatIndicator: number;
  jumpseatIdx: number;
  jumpseatOverrideFlag: string;
  basicOpWeight: number;
  zfw: number;
  grossPayload: number;
  payloadEqualsIndicator: number;
  payloadNotEqualsIndicator: number;
  grossPayloadBucket5000: number;
  tkGrossWeight: number;
  calculatedFuelWeight: number;
  rampGrossWeight: number;
  burnPounds: number;
  onBoardPounds: number;
  remainingPounds: number;
  landingWeight: number;
  maxAllowZfw: number;
  maxAllowTgw: number;
  maxAllowRgw: number;
  maxOpZfw: number;
  maxOpTgw: number;
  acl: number;
  aclDef: number;
  payloadDef: number;
  masterCons: number;
  tkGrossWeightIdx: number;
  latImbal: number;
  taxiFuel: number;
  takeoffFuel: number;
  takeoffFuelIdx: number;
  zfwPctMac: number;
  tgwPctMac: number;
  flightMode: string;
  zfwMinPct: number;
  zfwMaxPct: number;
  tgwMinPct: number;
  tgwMaxPct: number;
  ovwtrFlag: string;
  mnfstPrtCntr: number;
  mnfstPrtTime: Date;
  mnfstType: number;
  closeTime: Date;
  maxNumberJumpseat: number;
  basicOpWtIdx: number;
  zfwIdx: number;
  maxZfwRdctn: number;
  polarKitFlag: string;
  polarKitIndicator: number;
  fakFlag: string;
  fakIndicator: number;
  cloakedFlag: string;
  projectedTaxiFuel: number;
  liveAnimalsFlag: string;
  liveAnimalsIndicator: number;
  minFlightWeight: number;
  projectedMinFltWtFuel: number;
  revPayload: number;
  statusFlight: number;
  statusCalc: number;
  statusFuel: number;
  lastUpdateDate: Date;
  pctAssigned: number;
  pctLoaded: number;
  trunkFlag: string;
  plannedFuel: number;
  overrideFuelVariance: string;
  versionNumber: number;
  wbEnvelopeOid: number;
  cargoMoments: number;
  contactPhoneNumber: string;
  wbZfwEnvelopeOid: number;
  totalCargoIdx: number;
  ballastFuelIdx: number;
  mnfstPrtCntrFnl: number;
  verifyingRampAgent: number;
  avJumpseatQuantity: number;
  avJumpseatOverrideFlag: string;
  avOvwtrFlag: string;
  avOvwtrOverrideFlag: string;
  avFuelOverrideFlag: string;
  acarsReplyDate: Date;
  prelimManifestDate: Date;
  finalManifestDate: Date;
  newCalcFlag: string;
  maxFuelQuantity: number;
  preparingRampAgent: number;
  zfwrMinPct: number;
  zfwrMaxPct: number;
  zfwrPctMac: number;
  acarsStatusNumber: number;
  manifestSentDate: Date;
  manifestDeliveredDate: Date;
  acarsErrorDate: Date;
  fdrGeneratedDate: Date;
  lastTotalFuelQuantity: number;
  lastJumpseatQuantity: number;
  ifdrRampAgent: number;
  reopenTime: Date;
  acarsEquippedCode: string;
  avSendFlag: string;
  delCountNumber: string;
  actualMinFlightWtFuel: number;
  backToBlockCtr: number;
  rerouteCtr: number;
  dryIceFlag: string;
  dryIceIndicator: number;
  nfGasFlag: string;
  nfGasIndicator: number;
  radioactiveFlag: string;
  radioactiveIndicator: number;
  idgFlag: string;
  idgIndicator: number;
  adgFlag: string;
  adgIndicator: number;
  livesOnboardFlag: string;
  livesOnboardIndicator: number;
  uspsFlag: string;
  uspsIndicator: number;
  supplementalRulesFlag: string;
  burnFuelAmount: number;
  landingFuelIdx: number;
  landingGrossWeight: number;
  landingGrossWeightIdx: number;
  lgwMinPct: number;
  lgwMaxPct: number;
  lgwPctMac: number;
  maxAllowLgw: number;
  weightUnitCode: string;
  flightDataOid: string;
  revenueDepartureIndicator: number;
  nonRevenueDepartureIndicator: number;
  flightCountIndicator: number;
  flightNoDescription: string;
  flightNoAcftType: string;
  flightNoFlightType: string;
  flightNoRouteType: string;
  flightNoRangeCount: number;
  flightNoJetFeederFlag: string;
  flightNoOpsCode: string;
  flightNoOpsGroup: string;
  flightNoSeriesCode: string;
  flightNoFlightSeries: string;
  loadedCubeCount: number;
  flightCubeCodeRatio: number;
  nonVoidFlightCubeCodeRatio: number;
  voidedPositionRatio: number;
  flightContainsVoidedPositionIndicator: number;
  cubeCodeSum: number;
  effectiveVoidPositionCount: number;
  effectiveNonVoidPositionCount: number;
  averageTareWeightSum: number;
  revenueContainerWeightSum: number;
  averageCubicFeetSum: number;
  uldOnFlightWeightSum: number;
  aircraftDensity: number;
  aircraftRevenueDensity: number;
  flightCubeRatioBucket: number;
  gladNetWeight: number;
  gladPositionPackageCubeUsedPositions: number;
  gladAircraftPackageCubeUsedPositions: number;
  gladUsedCapacity: number;
  gladNonExcludedPositionCubeUsedPositions: number;
  gladNonExcludedAircraftCubeUsedPositions: number;
  gladNonExcludedUsedCapacity: number;
  gladNonExcludedUsedCapacityBucket: number;
  groupedFlightDate: string;
  flightDateFiscalYear: number;
  flightRouteDuplicateVariable: string;
  flightLoadedCapacityCalculatedDifference: number;
  flightNonVoidCapacityCalculatedDifference: number;
  dataWarehouseLoadTimestamp: Date;
}
